export enum IDType {
  KTP = "KTP",
  KITAS = "KITAS",
}
